"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.YANDEX_METRICS_IDS = void 0;
// Зашиваем ID внутрь, для уменьшения колва работы разработчиков при интеграции
var YANDEX_METRICS_IDS = {
  COMMON: 159737,
  WHITELABEL: 87750877
};
exports.YANDEX_METRICS_IDS = YANDEX_METRICS_IDS;